import { AddressMeterPointDetails } from "@/api/model"

export const AddressNotListed = "Address not listed"
export type AddressNotListedType = "Address not listed"
export type AddressFinderModel = AddressMeterPointDetails | AddressNotListedType
